import React, { Component } from 'react'
import PropTypes from 'prop-types'

const $ = window.$

class TabsSideBar extends Component {

	constructor(props) {
		super(props)
		this.state = {
			haveClick: false,
			defaultActive: true
		}
	}

	componentDidMount() {
		const sideComponent = $('.side-component')
		$('.side-tabs > ul').tabs()
		if (!this.state.defaultActive) {
			$('.side-tabs .tab > a').removeClass('active')
		}
		$('.close').click(() => {
			sideComponent.removeClass('open')
			this.setState({ haveClick: true })
		})
		$('.side-tabs .tab > a').click(e => {
			if (sideComponent.hasClass('open') && $(e.currentTarget).hasClass('active')) {
				sideComponent.removeClass('open')
			} else {
				sideComponent.addClass('open')
			}
			this.setState({ haveClick: true, defaultActive: false })
		})
		this.setHeight()
	}

	componentDidUpdate() {
		this.setHeight()
		const sideComponent = $('.side-component')
		if (this.props.isOpen && !this.state.haveClick) {
			sideComponent.addClass('open')
		}
	}

	setHeight() {
		const ribbonTop = ($('.ribbon').offset() || $('body').offset()).top
		const top = ribbonTop > 63 ? ribbonTop : 63
		const height = document.body.clientHeight - top
		$('.side-component').css({ 'height': `${height}px`, 'top': `${top}px` })
	}

	render() {
		const tabs = this.props.tabs.map((t, i) => {
			const className = (() => {
				if (t.defaultActive && this.state.defaultActive) {
					return 'active'
				}
				return ''
			})()
			return (
				<li key={ i } className='tab tooltipped' data-position='bottom' data-tooltip={ t.title || '' }>
					<a href={ `#sidetab${i}` } className={ className }>
						<i className='material-icons'>{ t.icon }</i>
					</a>
				</li>
			)
		})
		const tabsContent = this.props.tabs.map((t, i) => (
			<div key={ i } id={ `sidetab${i}` }>
				<h5><b>{ t.title }</b></h5>
				{ t.content }
			</div>
		))
		return (
			<div className='side-component'>
				<div className='side-tabs'>
					<ul>
						{ tabs }
					</ul>
				</div>
				<div className='content side-content'>
					{ tabsContent }
				</div>
			</div>
		)
	}

}

TabsSideBar.propTypes = {
	tabs: PropTypes.arrayOf(PropTypes.shape({
		icon: PropTypes.string,
		title: PropTypes.string,
		content: PropTypes.element,
		defaultActive: PropTypes.boolean
	})),
	isOpen: PropTypes.boolean
}

TabsSideBar.defaultProps = {
	tabs: [],
	isOpen: false
}

export default TabsSideBar



// WEBPACK FOOTER //
// ./src/components/navbar/TabsSideBar.js